const DownArrowIcon = () => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M5.17988 14.43C5.17988 14.24 5.24988 14.05 5.39988 13.9C5.68988 13.61 6.16988 13.61 6.45988 13.9L11.9999 19.44L17.5399 13.9C17.8299 13.61 18.3099 13.61 18.5999 13.9C18.8899 14.19 18.8899 14.67 18.5999 14.96L12.5299 21.03C12.2399 21.32 11.7599 21.32 11.4699 21.03L5.39988 14.96C5.24988 14.81 5.17988 14.62 5.17988 14.43Z"
			fill="white"
		/>
		<path
			d="M11.25 20.33L11.25 3.5C11.25 3.09 11.59 2.75 12 2.75C12.41 2.75 12.75 3.09 12.75 3.5L12.75 20.33C12.75 20.74 12.41 21.08 12 21.08C11.59 21.08 11.25 20.74 11.25 20.33Z"
			fill="white"
		/>
	</svg>
);
export default DownArrowIcon;
